import { format, subDays } from 'date-fns'

export const today = format(new Date(), 'yyyy-MM-dd')
export const sevenDaysAgo = format(subDays(new Date(), 6), 'yyyy-MM-dd')

export const getDateReceivedFilterType = (dateFrom: string, dateTo: string) => {
  if (dateFrom === '' && dateTo === '') {
    return null
  }
  if (dateFrom === today && dateTo === today) {
    return 'today'
  }
  if (dateFrom === sevenDaysAgo && dateTo === today) {
    return 'last7days'
  }
  return 'custom'
}
